// extracted by css-extract-rspack-plugin
export default {"scrollbarContainer":"HQFMQWhSpATwhgjn","scrollbarInner":"XUrnFRDXQo4KVKKg","scrollbarInput":"RJZMVcH7gQILl_a2"};